import React            from 'react'
import { Button       } from 'react-bootstrap'
import { SketchPicker } from 'react-color'

export default class ColorPicker extends React.Component
  constructor: (props) ->
    super(props)

    @state = { color: props.color or '#fff' }

  render: ->
    <div>
      <SketchPicker color={@state.color} onChangeComplete={(color) => @setState(color: color)} />
      <Button className="save-color-button" onClick={=> @props.onSave(@state.color)}>Uložit</Button>
    </div>
